/**
 * Shared keyboard-focus chrome for MuiButton, MuiIconButton, and MuiToggleButton
 * (including QSegmentedTabs). Ring value lives on `theme.palette.focusRings.button`.
 */
import type { Theme } from '@mui/material/styles';

/** `&.Mui-focusVisible` styles shared by Button and IconButton theme overrides. */
export function buttonFocusVisibleStyles(theme: Theme): {
  outline: 'none';
  boxShadow: string;
} {
  return {
    outline: 'none',
    boxShadow: theme.palette.focusRings.button,
  };
}
